module.exports = __webpack_public_path__ + "img/img8.5b8b30d2.svg";